import { PagingPanel } from '@devexpress/dx-react-grid-material-ui';
import { styled } from '@mui/material/styles';

export const CursorPagerComponent = styled(PagingPanel.Container)(({ theme }) => ({
  borderTop: `1px solid ${theme.palette.divider}`,
  '& div:nth-of-type(2) .Pagination-button': {
    display: 'none'
  }
}));
